import { OTPInput, SlotProps } from "input-otp";

interface SmsCodeInputProps {
  value: string;
  onChange: (value: string) => void;
}

function SmsCodeSlot({ char, hasFakeCaret }: SlotProps) {
  return (
    <div
      className="
        relative flex h-[70px] w-[60px]
        items-center justify-center
        rounded-[4px] border border-solid border-[#999999]
        bg-white text-[28px] font-bold
      "
    >
      {char}

      {hasFakeCaret ? (
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
          <div className="h-[30px] w-px animate-caret-blink bg-black" />
        </div>
      ) : null}
    </div>
  );
}

export default function SmsCodeInput({ value, onChange }: SmsCodeInputProps) {
  const handleChange = (newValue: string) => {
    if (!/^\d*$/.test(newValue)) return;

    onChange(newValue);
  };

  return (
    <OTPInput
      maxLength={4}
      value={value}
      onChange={handleChange}
      inputMode="numeric"
      containerClassName="flex gap-3"
      render={({ slots }) => (
        <>
          {slots.map((slot, index) => (
            <SmsCodeSlot key={index} {...slot} />
          ))}
        </>
      )}
    />
  );
}
